var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.station.sum,
          expression: "station.sum"
        }
      ],
      staticClass: "marker"
    },
    [
      _c("p", { staticClass: "t15 u-cut w7" }, [
        _vm._v(_vm._s(_vm.station.name))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "t12 u-cut" }, [
        _c("span", { staticClass: "w7 cl-orange" }, [
          _vm._v(_vm._s(_vm.station.sum) + "件")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("該当中")])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }